<h1 mat-dialog-title>Info</h1>
<mat-dialog-content>{{data.message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button color="primary"
            mat-button
            mat-dialog-close>OK
    </button>
</mat-dialog-actions>